import React, { useState } from "react"
import { AppBar, Box, Tab, Tabs, Typography } from "@material-ui/core";
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import Spinner from "web/components/Spinner";
import Breadcrumb from "web/components/Breadcrumb";
import OrderInvoices from "./Tabs/OrderInvoices";
import { Container, TableWrapper } from "../Reports/reportsStyled";
import { Heading } from "../../adminStyled";
import AdjustmentInvoices from "./Tabs/AdjustmentInvoices";

function Invoices({ scrollTop }) {
  const adminRoles = useSelector(state => state.admin.adminRoles)
  const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
  const [value, setValue] = useState(0);

  let breadcrumbMapArr = [
    {
      name: "PT+ Admin",
      link: "ptplus-user-managememt",
      eventType: "",
    },
  ];

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            {/* <Typography>{children}</Typography> */}
            <div>{children}</div>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  //change tab index
  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {(adminRoles && (adminRoles.includes('PT_PLUS') || adminRoles.includes('SUPER_ADMIN'))) ?
        <Container>
          <Breadcrumb
                breadcrumbArr={breadcrumbMapArr}
                selected='Invoices'
                title=""
              />
          <TableWrapper>
            {(loaderVisible) && <Spinner />}
            <div className="column">
              <Heading>
                <h3>Invoices</h3>
              </Heading>
            </div>

            <AppBar position="static">
              <Tabs value={value} onChange={handleChangeTab} aria-label="simple tabs example">
                <Tab label="Invoices" {...a11yProps(0)} />
                <Tab label="Adjustment Invoices" {...a11yProps(1)} />
              </Tabs>
            </AppBar>
            <OrderInvoices
              TabPanel={TabPanel}
              value={value}
            />
            <AdjustmentInvoices
              TabPanel={TabPanel}
              value={value}
            />
          </TableWrapper>
        </Container>
        :
        <p>You are not authorized to view this page.</p>
      }
    </>
  )
}

export default Invoices